import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import AppRoutes from './routes';
import CacheBuster from 'react-cache-buster';
import packageInfo from '../package.json';
import { MotionProvider } from './motion';
import ErrorBoundary from './components/ui/ErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <CacheBuster
      currentVersion={packageInfo.version}
      isEnabled={process.env.NODE_ENV === 'production'}
      isVerboseMode={false}
      metaFileDirectory={'.'}
    >
      <ErrorBoundary>
        <MotionProvider>
          <AppRoutes />
        </MotionProvider>
      </ErrorBoundary>
    </CacheBuster>
  </React.StrictMode>
);

reportWebVitals();
